
/**
 * 判断是否有权限。根据传入的权限标识，查看是否存在于用户的权限标识集合内。
 */
export function hasPermission (button_name,view_name) {
    let check_admin = sessionStorage.getItem('name')
    if (check_admin == 'admin')
        return true
    let hasPermission = false;
    let menus =  sessionStorage.getItem('menus');
    let menus2 =  sessionStorage.getItem('menus2');
    let buttons = sessionStorage.getItem('buttons');
    let buttonId = 0;
    let viewId = ''
    // console.log(button_name,view_name)
    for (let item of JSON.parse(menus)) {
        if (item.value == view_name && item.view == 0)
            {
                viewId = item.id;
                break;
            }
    }
    // console.log("viewId==="+ viewId)

    for (let item of JSON.parse(menus)) {
        if (item.view ==  viewId && item.value == button_name) {
            // hasPermission = true;
            buttonId = item.id;
            break;
        }
    }

    // console.log("buttonId==="+ buttonId)


    for (let item of buttons.split(",")) {
        if (item == buttonId){
            hasPermission = true;
            return hasPermission
        }

    }

    if (button_name == '0'){
        console.log(viewId)
        for (let item of menus2.split(",")) {
            if (item == viewId || item.toString() == viewId  ){
                hasPermission = true;
                break;
            }

        }
    }



    return hasPermission;
}




// WEBPACK FOOTER //
// ./src/premission.js